import { generateCountryUrl } from './utils/linkUtils';

export const countries = [
  // Americas & Oceania
  { id: 1, name: 'United States', continent: 'Americas & Oceania', coords: { top: '38%', left: '19%' }, flag: '🇺🇸' },
  { id: 2, name: 'Canada', continent: 'Americas & Oceania', coords: { top: '25%', left: '19%' }, flag: '🇨🇦' },
  { id: 3, name: 'Mexico', continent: 'Americas & Oceania', coords: { top: '49%', left: '19%' }, flag: '🇲🇽' },
  { id: 5, name: 'Australia', continent: 'Americas & Oceania', coords: { top: '78%', left: '83%' }, flag: '🇦🇺' },

  // Asia
  { id: 6, name: 'India', continent: 'Asia', coords: { top: '53%', left: '69%' }, flag: '🇮🇳' },

  // Europe
  { id: 4, name: 'United Kingdom', continent: 'Europe', coords: { top: '31%', left: '47%' }, flag: '🇬🇧' },
  
  // Ready-to-use, just uncomment:
  // { id: 7, name: 'Austria', continent: 'Europe', coords: { top: '36%', left: '51%' }, flag: '🇦🇹' },
  // { id: 8, name: 'Belgium', continent: 'Europe', coords: { top: '34%', left: '48%' }, flag: '🇧🇪' },
  // { id: 9, name: 'Bulgaria', continent: 'Europe', coords: { top: '39%', left: '54%' }, flag: '🇧🇬' },
  // { id: 10, name: 'Czech Republic', continent: 'Europe', coords: { top: '35%', left: '52%' }, flag: '🇨🇿' },
  // { id: 11, name: 'Denmark', continent: 'Europe', coords: { top: '30%', left: '50%' }, flag: '🇩🇰' },
  // { id: 12, name: 'France', continent: 'Europe', coords: { top: '37%', left: '48%' }, flag: '🇫🇷' },
  // { id: 13, name: 'Germany', continent: 'Europe', coords: { top: '34%', left: '50%' }, flag: '🇩🇪' },
  // { id: 14, name: 'Greece', continent: 'Europe', coords: { top: '43%', left: '53%' }, flag: '🇬🇷' },
  // { id: 15, name: 'Iceland', continent: 'Europe', coords: { top: '22%', left: '42%' }, flag: '🇮🇸' },
  // { id: 16, name: 'Ireland', continent: 'Europe', coords: { top: '32%', left: '45%' }, flag: '🇮🇪' },
  // { id: 17, name: 'Italy', continent: 'Europe', coords: { top: '40%', left: '51%' }, flag: '🇮🇹' },
  // { id: 18, name: 'Norway', continent: 'Europe', coords: { top: '24%', left: '50%' }, flag: '🇳🇴' },
  // { id: 19, name: 'Poland', continent: 'Europe', coords: { top: '33%', left: '53%' }, flag: '🇵🇱' },
  // { id: 20, name: 'Portugal', continent: 'Europe', coords: { top: '41%', left: '45%' }, flag: '🇵🇹' },
  // { id: 21, name: 'Romania', continent: 'Europe', coords: { top: '36%', left: '54%' }, flag: '🇷🇴' },
  // { id: 22, name: 'Russian Federation', continent: 'Europe', coords: { top: '30%', left: '70%' }, flag: '🇷🇺' },
  // { id: 23, name: 'Sweden', continent: 'Europe', coords: { top: '24%', left: '52%' }, flag: '🇸🇪' },
  // { id: 24, name: 'Switzerland', continent: 'Europe', coords: { top: '37%', left: '50%' }, flag: '🇨🇭' },
  // { id: 25, name: 'Ukraine', continent: 'Europe', coords: { top: '34%', left: '56%' }, flag: '🇺🇦' },

];

export const continents = ['Europe', 'Asia', 'Americas & Oceania', 'Africa'];

// Helper function to get country link
export function getCountryLink(country) {
  return generateCountryUrl(country.name);
}
